// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"280":"d8ff3c80","618":"9a6b3afa","931":"9682c131"}[chunkId] + ".chunk.js";
};